import { useEffect, useLayoutEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

const KEY = "rv_scroll_positions";
const read = () => {
  try { return JSON.parse(sessionStorage.getItem(KEY) || "{}"); } catch { return {}; }
};

// Back/forward restores the exact Y position (waiting for lazy content to grow the page); new pages start at top.
export const ScrollMemory = () => {
  const location = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    if ("scrollRestoration" in window.history) window.history.scrollRestoration = "manual";
  }, []);

  useEffect(() => {
    let t;
    const save = () => {
      clearTimeout(t);
      t = setTimeout(() => {
        const all = read();
        all[location.key] = window.scrollY;
        sessionStorage.setItem(KEY, JSON.stringify(all));
      }, 120);
    };
    window.addEventListener("scroll", save, { passive: true });
    return () => { clearTimeout(t); window.removeEventListener("scroll", save); };
  }, [location.key]);

  useLayoutEffect(() => {
    if (navType !== "POP") {
      if (!location.hash) window.scrollTo(0, 0);
      return undefined;
    }
    const y = read()[location.key];
    if (!y) return undefined;
    let tries = 0;
    const id = setInterval(() => {
      tries += 1;
      if (document.documentElement.scrollHeight >= y + window.innerHeight || tries > 40) {
        window.scrollTo(0, y);
        clearInterval(id);
      }
    }, 75);
    return () => clearInterval(id);
  }, [location.key, navType, location.hash]);

  return null;
};
